import { Component } from "react";

export default class GameErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[GameErrorBoundary]", error, info.componentStack);
    // Forward to Sentry if it loaded
    try {
      if (window.__SENTRY__) window.__SENTRY__.captureException(error);
    } catch {}
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center gap-4 p-8 text-center">
          <div className="text-2xl font-bold text-red-400">Something went wrong</div>
          <div className="text-sm text-slate-400 max-w-sm">
            An unexpected error occurred in the game. Refresh the page to rejoin — your game is still saved.
          </div>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 rounded bg-amber-500 hover:bg-amber-600 text-black font-bold text-sm"
          >
            Refresh
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
